import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Step } from 'types/enums';

export interface StepState {
  currentStep: Step;
}

const initialState: StepState = {
  currentStep: Step.BusinessDetails,
};

export const stepSlice = createSlice({
  name: 'step',
  initialState,
  reducers: {
    /*
     * Redux Toolkit allows us to write "mutating" logic in reducers. It
     * doesn't actually mutate the state because it uses the Immer library,
     * which detects changes to a "draft state" and produces a brand new
     * immutable state based off those changes
     */
    toStep: (state, action: PayloadAction<Step>) => {
      state.currentStep = action.payload;
    },
  },
});

/* Fully typed Action creators are automagically generated for each case reducer function */
export const { toStep } = stepSlice.actions;

export default stepSlice.reducer;
